import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { DesignThemeConfig } from '@/stores/design-preview-store';

interface DesignSandboxState {
  /**
   * The candidate design currently being edited/previewed in the sandbox. Null
   * means "show the live theme" (no candidate). Persisted to localStorage so an
   * admin can resume after a reload. Never the source of truth for live
   * visitors — publishing (Phase 4) is what writes site_settings.theme_config.
   */
  candidate: DesignThemeConfig | null;
  /** Replace the whole candidate (gallery pick, AI apply, load draft). */
  setCandidate: (config: DesignThemeConfig | null) => void;
  /** Merge a partial change (fine-tune controls). */
  patchCandidate: (partial: Partial<DesignThemeConfig>) => void;
  /** Drop the candidate and return to previewing the live theme. */
  clearCandidate: () => void;
}

export const useDesignSandboxStore = create<DesignSandboxState>()(
  persist(
    (set) => ({
      candidate: null,
      setCandidate: (config) => set({ candidate: config }),
      patchCandidate: (partial) =>
        set((s) => ({ candidate: { ...(s.candidate ?? {}), ...partial } })),
      clearCandidate: () => set({ candidate: null }),
    }),
    { name: 'rumio-design-sandbox' },
  ),
);
